/**
 * ConversationListSkeleton Component - HYB Shop Chat
 * Loading skeleton matching ConversationListItem layout
 */


import { cn } from '../../../utils/responsive';

interface ConversationListSkeletonProps {
  count?: number;
  className?: string;
}

function SkeletonItem() {
  return (
    <div className="flex items-start gap-3 px-4 py-3.5 animate-pulse">
      {/* Avatar skeleton */}
      <div className="h-10 w-10 rounded-full bg-stone-200 dark:bg-gray-700 flex-shrink-0" />

      {/* Content skeleton */}
      <div className="flex-1 space-y-2.5">
        {/* Name + badge row */}
        <div className="flex items-center justify-between">
          <div className="h-4 w-28 rounded bg-stone-200 dark:bg-gray-700" />
          <div className="h-4 w-4 rounded-full bg-stone-200 dark:bg-gray-700" />
        </div>

        {/* Phone */}
        <div className="h-3 w-20 rounded bg-stone-100 dark:bg-gray-700/50" />

        {/* Message preview */}
        <div className="h-3 w-full rounded bg-stone-100 dark:bg-gray-700/50" />

        {/* Time + unread row */}
        <div className="flex items-center justify-between">
          <div className="h-2.5 w-16 rounded bg-stone-100 dark:bg-gray-700/50" />
        </div>
      </div>
    </div>
  );
}

export function ConversationListSkeleton({
  count = 5,
  className,
}: ConversationListSkeletonProps) {
  return (
    <div className={cn('divide-y divide-stone-100 dark:divide-gray-700', className)}>
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonItem key={index} />
      ))}
    </div>
  );
}

export default ConversationListSkeleton;
